import { parseEventDescription } from 'shared/domain/issueEvent/parseEventDescription';
import { MentionToViewMapper } from 'components/dataProviders/withIssue/eventDescription';
import { objHasKey } from 'shared/utils/object';
import { HashMap, LabelledEntity } from 'shared/types/commonView';
import { EventDescriptionPartModel } from 'shared/domain/issue/issueModel';
import { EventDescriptionType } from 'shared/types/eventDescription';
import { UserOnView } from 'shared/domain/user/types/view';

export function deduplicateMentionedUsers(
  eventDescriptionWithMarkup: string
): LabelledEntity[] {
  const deduplicateHelper: HashMap<boolean> = {};
  return parseEventDescription(eventDescriptionWithMarkup)
    .filter(isMention)
    .filter((mention: MentionToViewMapper): boolean => {
      return objHasKey(deduplicateHelper, mention.user._id)
        ? false
        : (deduplicateHelper[mention.user._id] = true);
    })
    .map((mention) => mention.user);
}

export function deduplicateMentionedUsersInSummary(
  mentionedUsers: UserOnView[]
): UserOnView[] {
  return mentionedUsers.filter(
    (user, index, self) =>
      index === self.findIndex((t) => t._id === user._id)
  );
}

export function isMention(
  description: EventDescriptionPartModel
): description is MentionToViewMapper {
  return description.type === EventDescriptionType.mention;
}
